import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-toggle',
  templateUrl: './toggle.component.html',
  styleUrls: ['./toggle.component.scss'],
})
export class ToggleComponent {
  @Input() allowChanges: boolean;
  @Input() enabled: boolean;
  @Output() toggle = new EventEmitter<boolean>();
  @Output() action = new EventEmitter();

  handleToggle(event: any) {
    if (!this.allowChanges) event.preventDefault();
    this.enabled = !this.enabled;
    this.toggle.emit(this.enabled);
    this.action.emit('status');
  }
}
